import { ROUTES } from "@/constants/routes";

import { NavTo } from "../routing-types";
import { isWatchlistItemPathname } from "../watchlist/paths";

/**
 * `location.state` for `/events/:id` when the user navigated from a list
 * (dashboard, all-activity, or a watch detail page). Always use a `kind`
 * discriminator so the `EventsRouterState` union stays narrowable.
 */
export type EventDetailsOrigin =
	| `${typeof ROUTES.WATCHLIST}/${string}`
	| typeof ROUTES.ALL_ACTIVITY
	| typeof ROUTES.DASHBOARD;

export type EventItemsRouterState = {
	kind: NavTo<"event-details">;
	origin: EventDetailsOrigin;
};

export function createEventItemsRouterState(
	origin: EventDetailsOrigin,
): EventItemsRouterState {
	return { kind: "to:event-details", origin };
}

/** Attach router state when navigating to event details from a known list page. */
export function getEventDetailsRouterStateFromPathname(
	pathname: string,
): EventItemsRouterState | undefined {
	if (pathname === ROUTES.DASHBOARD) {
		return createEventItemsRouterState(ROUTES.DASHBOARD);
	}
	if (pathname === ROUTES.ALL_ACTIVITY) {
		return createEventItemsRouterState(ROUTES.ALL_ACTIVITY);
	}
	if (isWatchlistItemPathname(pathname)) {
		return createEventItemsRouterState(pathname);
	}
	return undefined;
}

export function isEventDetailsOrigin(
	value: unknown,
): value is EventDetailsOrigin {
	if (value === ROUTES.DASHBOARD || value === ROUTES.ALL_ACTIVITY) {
		return true;
	}

	return isWatchlistItemPathname(value);
}
